<template>
    <div id="contenedor-agregar-respuesta-detalle-documento">
      <v-form v-model="formularioValido" ref="formAgregarRespuestaDetalleDocumento">
        <v-card>
          <v-card-title class="secondary--text">
            Agregar archivo
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-row align="center" justify="center">
                <v-btn text large icon class="secondary--text" @click="seleccionarArchivo">
                  <v-icon center>
                    mdi-paperclip
                  </v-icon>
                </v-btn>
                <template v-if="nombreArchivoSeleccionado">
                  <span>{{ nombreArchivoSeleccionado }}</span>
                </template>
                <template v-else>
                  <span> Seleccionar Archivo </span>
                </template>
              </v-row>
            </v-row>
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              class="mr-3"
              tipo="formCancelar"
              label="Cancelar"
              @click="cerrar">
            </custom-button>
            <custom-button
              tipo="formAceptar"
              label="Guardar"
              :disabled="!formularioValido || enviandoFormulario"
              :loading="enviandoFormulario"
              @click="guardar">
            </custom-button>
          </v-card-actions>
        </v-card>
          <v-file-input
          v-show="false"
          show-size
          type="file"
          ref="anexoDocumento"
          name="anexo"
          id="anexo"
          accept=".pdf"
          @change="seleccion"
          :rules="[mixReglas.requerido]"
        >
        </v-file-input>
      </v-form>
    </div>
</template>

<script>
import mixAuditoriaRespuestaDetalleDocumentos from './mixAuditoriaRespuestaDetalleDocumentos';
import CustomButton from '@/components/buttons/Button.vue';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';

export default {
  name: 'AgregarDocumentoDetalleRespuesta',
  mixins: [mixAuditoriaRespuestaDetalleDocumentos, mixSubirArchivo],
  props: {
    idDetalle: {
      type: String,
      required: true,
    },
    idRespuesta: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      contador: 0,
      nombreArchivoSeleccionado: null,
      formularioValido: false,
      enviandoFormulario: false,
      documento: {
        idAuditoriaInformeRespuestaDetalle: this.idDetalle,
        nombre: '',
        fileData: null,
      },
    };
  },
  methods: {
    async guardar() {
      this.enviandoFormulario = true;
      const datosArchivo = this.setDatosArchivo();
      const archivo = await this.mixSubirArchivo(datosArchivo);
      if (archivo.status === 'ok') {
        this.documento.fileData = JSON.stringify(archivo.data);
        this.documento.nombre = this.nombreArchivoSeleccionado;
        this.mixAgregarDetalleDocumento();
      }
    },
    setDatosArchivo() {
      const datos = {
        nombre: `${this.nombreArchivoSeleccionado}`,
        path: 'Auditorias/Respuestas/Detalles/Documentos',
      };
      return datos;
    },
    cerrar() {
      this.$refs.formAgregarRespuestaDetalleDocumento.reset();
      this.$emit('cerrar');
    },
    seleccionarArchivo() {
      document.getElementById('anexo').click();
    },
    seleccion() {
      this.nombreArchivoSeleccionado = document.getElementById('anexo').files[0]?.name;
    },
  },
};
</script>

  <style lang="scss"></style>
